import api from "./capTableApi";
import { CustomResponse } from "../types/CustomResponse";
import { CompanyUser, RoleGrant } from "../types/User";

export type AddCompanyUserInput = {
  companyId: string;
  fullName: string;
  emailId: string;
  roleId: number;
  roleName: string;
  designation: string;
  silentAccess: boolean;
};

export async function addUserToCompany(
  data: AddCompanyUserInput
): Promise<CustomResponse<CompanyUser>> {
  return api.post("/v1/auth/userAccess", data).then((res) => res.data);
}

export async function deleteCompanyUser(data: {
  companyId: string;
  userId: number;
}): Promise<CustomResponse<unknown>> {
  return api
    .post("/v1/auth/removeUserAccessCompany", undefined, { params: data })
    .then((res) => res.data);
}

export type BulkAssignUserInput = {
  companyIds: string[];
  emails: string[];
  roleName: string;
  designation: string;
  roleGrants: RoleGrant[];
  silentAccess: boolean;
  fullNameByEmail?: Record<string, string>;
};

export async function bulkAssignUsersToCompanies(
  input: BulkAssignUserInput
): Promise<CustomResponse<unknown>> {
  return api.post("/v1/auth/bulkUserAccessCompany", input).then((res) => res.data);
}

export type AccountUser = {
  id?: number;
  userId?: number;
  fullName?: string;
  name?: string;
  emailId?: string;
  email?: string;
};

export async function getAccountUsers(): Promise<AccountUser[]> {
  return api.get("/v1/taskManager/account-users").then((res) => res.data.data);
}
